export const testimonials = [
    {
      id: 1,
      name: 'Sarah Johnson',
      location: 'London',
      rating: 5,
      date: '2024-01-15',
      comment: 'Absolutely fantastic service! My car looks brand new. The team was professional, punctual, and the attention to detail was incredible.',
      service: 'Gold Package',
    },
    {
      id: 2,
      name: 'David Mitchell',
      location: 'Surrey',
      rating: 5,
      date: '2024-01-10',
      comment: 'Best mobile valeting service I\'ve used. They came to my office and did an amazing job while I was in meetings.',
      service: 'Silver Package',
    },
    {
      id: 3,
      name: 'Emma Williams',
      location: 'Kent',
      rating: 5,
      date: '2024-01-05',
      comment: 'The Platinum package was worth every penny. My 5-year-old car looks like it just came out of the showroom!',
      service: 'Platinum Package',
    },
    {
      id: 4,
      name: 'James Brown',
      location: 'Essex',
      rating: 5,
      date: '2025-11-20',
      comment: 'Great value for money. Bronze package is perfect for my weekly clean.',
      service: 'Bronze Package',
    },
    {
      id: 5,
      name: 'Lisa Anderson',
      location: 'Hertfordshire',
      rating: 5,
      date: '2025-11-18',
      comment: 'They removed all the pet hair from my car seats - something I thought was impossible!',
      service: 'Silver + Pet Hair Removal',
    },
    {
      id: 6,
      name: 'Michael Roberts',
      location: 'Berkshire',
      rating: 5,
      date: '2025-10-15',
      comment: 'Outstanding service from start to finish. Booked via WhatsApp, very easy communication.',
      service: 'Gold Package',
    },
  ];